import Ajv from 'ajv'
import addFormat from './format'
import localize from './localize'
import { isArray, forEach, isString, isNil, isObject, isEmpty } from 'lodash'

const ajv = new Ajv({
  $data: true,
  useDefaults: true,
  allErrors: true,
  jsonPointers: true,
  format: 'fast',
  formats: {
    /* eslint-disable no-useless-escape */
    loginName: /^\S{6,40}$/,
    password: /^\S{6,20}$/,
    // 新密码格式要求
    // 1、密码长度8-15位；
    // 2、需包括大写字母、小写字母、数字、特殊符号4种中的至少3种，特殊字符仅支持：`~!@#$%^&*()_+-=][{}|:;\,<.?/>
    newPassword: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+\-=\[\]{}|:;,.<>\/?]).{8,15}$|^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,15}$|^(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*()_+\-=\[\]{}|:;,.<>\/?]).{8,15}$|^(?=.*[a-z])(?=.*\d)(?=.*[~!@#$%^&*()_+\-=\[\]{}|:;,.<>\/?]).{8,15}$|^(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+\-=\[\]{}|:;,.<>\/?]).{8,15}$/,
    idCard: /^[0-9A-Za-z]{4,50}$/,
    token: /^[0-9]{6}$/,
    phone: /^1[3|4|5|6|7|8|9]\d{9}$/,
    captcha: /^[a-zA-Z0-9]{4}$/,
    countryCode: /^\d+$/,
    'date-time': /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d:\d\d)?$/i
  }
})

addFormat(ajv)

export function validate (uri, data, path) {
  return new Promise(resolve => {
    const schema = require(`@/validate/${uri}`)
    const validate = ajv.compile(schema)

    // 移除无值结果，保证required校验有效
    removeEmptyValue(data)

    const valid = validate(data)

    if (!valid) {
      localize(validate.errors, ajv.errors || [], schema, ajv)
      const allErrors = parseErrors(validate.errors)

      if (allErrors[path]) {
        resolve({
          valid,
          error: allErrors[path].message
        })
      }

      resolve({
        valid
      })
    } else {
      resolve({
        valid
      })
    }
  })
}

function removeEmptyValue (model) {
  const isArr = isArray(model)

  forEach(model, (value, key) => {
    if (isNil(value) || (isString(value) && !value)) {
      isArr ? model.splice(key, 1) : delete model[key]
      return
    }

    if (isObject(value)) {
      if (isEmpty(value)) {
        delete model[key]
      } else {
        removeEmptyValue(value)
      }
    }
  })
}

function parseErrors (errors) {
  const map = {}

  errors.forEach(err => {
    map[err.path] = err
  })

  return map
}
